const TechCard = ({title, techStacks}) => {
    return(
        <div className="group">
            <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl p-6 shadow-sm transition-all duration-300">
                <h3 className="text-slate-900 dark:text-white font-bold text-xl mb-6 flex items-center gap-2 transition-colors duration-300">
                    <div className="w-1 h-6 bg-slate-900 dark:bg-slate-400 rounded-full"></div>
                    {title}
                </h3>
                
                <div className="grid grid-cols-4 sm:grid-cols-5 lg:grid-cols-6 gap-4">
                    {techStacks?.map(({name, iconUrl}, index) => (
                        <div 
                            key={index}
                            className="group/tech relative flex flex-col items-center p-3 bg-slate-50 dark:bg-slate-900/50 rounded-xl border border-slate-100 dark:border-slate-700/50 hover:bg-slate-100 dark:hover:bg-slate-700 hover:-translate-y-1 transition-all duration-300"
                        >
                            <img 
                                width="40" 
                                height="40" 
                                src={iconUrl} 
                                alt={name}
                                className="transition-all duration-300 group-hover/tech:scale-110" 
                            />
                            <span className="text-xs font-medium text-slate-600 dark:text-slate-400 mt-2 text-center leading-tight transition-colors duration-300">
                                {name}
                            </span>
                            
                            {/* Hover effect overlay removed */}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default TechCard;